import App from "@app/App";
import AboutUs from "@pages/AboutUs/AboutUs";
import ArticlePage from "@pages/Article/Article";
import TmPicks from "@pages/Article/TmPicks";
import AuthorPage from "@pages/Author/AuthorPage";
import BalarMurasu from "@pages/BalarMurasu/BalarMurasu";
import GePage from "@pages/CustomPages/GePage";
import Tm90 from "@pages/CustomPages/Tm90";
import HomePage from "@pages/Home/Home";
import Horoscope from "@pages/Horoscope/Horoscope";
import KeywordPage from "@pages/Keyword/Keyword";
import Newsletter from "@pages/Newsletter/Newsletter";
import { NewsletterUnsubscribePage } from "@pages/Newsletter/NewsletterUnsubscribe";
import NotFound from "@pages/NotFound";
import PhotoGalleryPage from "@pages/PhotoGallery/PhotoGallery";
import PhotoGalleryDetailPage from "@pages/PhotoGallery/PhotoGalleryDetailPage";
import PodcastPage from "@pages/Podcast/Podcast";
import QuizPage from "@pages/Quiz/Quiz";
import RecentArticlesPage from "@pages/RecentArticles/RecentArticles";
import { SearchResultPage } from "@pages/Search/SearchResult";
import SectionPage from "@pages/Section/Section";
import TranslationPage from "@pages/Translation/Translation";
import VideoPage from "@pages/Video/Video";
import VideoDetailPage from "@pages/Video/VideoDetailPage";
import { fetchContext } from "@sphtech/web2-core/ssr";
import { RouteObject } from "react-router";

export const reactRouterRoutes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <HomePage />,
        loader: fetchContext,
      },
      {
        path: "/horoscope/:zodiac",
        element: <Horoscope />,
        loader: fetchContext,
      },
      {
        path: "/article/:id",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/videos",
        element: <VideoPage />,
        loader: fetchContext,
      },
      {
        path: "/videos/:level1",
        element: <VideoDetailPage />,
        loader: fetchContext,
      },
      {
        path: "/tm-picks/:level1",
        element: <TmPicks />,
        loader: fetchContext,
      },
      {
        path: "/podcasts",
        element: <PodcastPage />,
        loader: fetchContext,
      },
      {
        path: "/podcasts/:level1",
        element: <PodcastPage />,
        loader: fetchContext,
      },
      {
        path: "/recent-articles",
        element: <RecentArticlesPage />,
        loader: fetchContext,
      },
      {
        path: "/balar-murasu",
        element: <BalarMurasu />,
        loader: fetchContext,
      },
      {
        path: "/photo-gallery",
        element: <PhotoGalleryPage />,
        loader: fetchContext,
      },
      {
        path: "/photo-gallery/:slug",
        element: <PhotoGalleryDetailPage />,
        loader: fetchContext,
      },
      {
        path: "/general-election-2025",
        element: <GePage />,
        loader: fetchContext,
      },
      {
        path: "/keywords/:level1",
        element: <KeywordPage />,
        loader: fetchContext,
      },
      {
        path: "/author/:level1",
        element: <AuthorPage />,
        loader: fetchContext,
      },
      {
        path: "/search/site/:searchValue",
        element: <SearchResultPage />,
        loader: fetchContext,
      },
      {
        path: "/newsletter/unsubscribe",
        element: <NewsletterUnsubscribePage />,
        loader: fetchContext,
      },
      {
        path: "/:section/:slug",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/newsletter/sign-up",
        element: <Newsletter />,
      },
      {
        path: "/tamil-translation-service-singapore",
        element: <TranslationPage />,
        loader: fetchContext,
      },
      {
        path: "/about-us",
        element: <AboutUs />,
        loader: fetchContext,
      },
      {
        path: "/tamil-quiz",
        element: <QuizPage />,
        loader: fetchContext,
      },
      {
        path: "/tm90",
        element: <Tm90 />,
        loader: fetchContext,
      },
      {
        path: "/:level1",
        element: <SectionPage />,
        loader: fetchContext,
      },
      {
        path: "*",
        element: <NotFound />,
        loader: fetchContext,
      },
    ],
  },
];

export const routes = reactRouterRoutes.reduce(
  (_routes: string[], currentRoute: RouteObject) => {
    if (currentRoute.path) {
      _routes = [..._routes, currentRoute.path];
    }

    if (currentRoute.children) {
      for (const child of currentRoute.children) {
        if (child.path) {
          _routes = [..._routes, child.path];
        }
      }
    }

    return _routes;
  },
  [],
);
